module.exports = "/images/copy-icon.svg?8919022095ffbe855692470e64e28cd8";